import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions,URLSearchParams } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class MainService {   
    public commentUrl = "mock-data/comment-mock.json";
    public homeUrl = "mock-data/home-mock.json";
    public industryUrl = "mock-data/industry-mock.json";
    public aboutUrl = "mock-data/about-mock.json";

    constructor(public http: Http) {}

    public getCommentData():Observable<any>{
        return this.http.get(this.commentUrl)
            .map((res: Response) => res.json())
    }
    public getHomeData():Observable<any>{
        return this.http.get(this.homeUrl)
            .map((res: Response) => res.json())
    }
    public getIndustryData():Observable<any>{
        return this.http.get(this.industryUrl)
            .map((res: Response) => res.json())
    }
    public getAboutData():Observable<any>{
        return this.http.get(this.aboutUrl)
            .map((res: Response) => res.json())
    }
}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/service/main.service.ts